import { Fetch, State } from "common/types/global";
import { IBus } from "@sg-widgets/platform-api";
import { Env } from "common/api/apiUrls";

export interface IO<T> {
  maxItemNameLength?: number;
  capacity: number;
  filter: { [x: string]: string[] | number[] };
  fetch: Fetch;
  headers: { [x: string]: string };
  onChange: (items: T[]) => void;
  placeholder: string;
  readonlyIds: string[];
  selectedIds: string[];
  selectedSearchBy: string;
  displaySearchBy: boolean;
  soaUrl: string;
  ssoV2: boolean;
  state: State;
  userEmail: string;
  displayInline?: boolean;
  bus: IBus;
  emitOnMount?: boolean;
  env: Env;
}

export const FilterKeyMapper: { [key: string]: string } = {
  level: "clientIds.internalId.level",
};

export const FilterValueMapper = {
  level: [
    "Grp",
    "SubGrp",
    "SubGrpDiv",
    "LE Grp",
    "LE",
    "Sub-LE",
    "EC",
    "Sub-EC",
  ],
};
